// extracted by mini-css-extract-plugin
export var actions = "_ue-4";
export var item = "_ue-1";
export var price = "_ue-3";
export var quantity = "_ue-2";
export var table = "_ue-0";